/* global gigya */
import idMixin from '@/mixins/aha-id';

export default {
    mixins: [idMixin],
    render(h) {
        const gigya = h(
            'div', {
                class: 'c-share c-share--gigya',
                attrs: {
                    id: this.shareId
                }
            }
        );

        const container = h(
            'div', {
                class: 'c-social'
            }, [gigya, this.hasDefaultSlot && this.$slots.default]
        );

        return container;
    },
    props: {
        shareButtons: {
            type: Array
        },
        description: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        imageUrl: {
            type: String,
            default: ''
        },
        tags: {
            type: String,
            default: ''
        }
    },
    computed: {
        shareId: function() {
            return this.safeId('_AHA-gigya-social');
        },
        hasDefaultSlot () {
            return !!this.$slots.default;
        }
    },
    mounted() {
        var act = new gigya.socialize.UserAction();

        act.setDescription(this.description);
        act.setTitle(this.title);
        act.addMediaItem({
            type: 'image',
            src: this.imageUrl
        });

        var showShareBarUiParams = {
            containerID: this.shareId,
            tags: this.tags,
            wrap: 'true',
            iconsOnly: 'true',
            showTooltips: 'true',
            layout: 'horizontal',
            shortURLs: 'never',
            showCounts: 'none',
            shareButtons: this.shareButtons || [
                {
                    provider: 'facebook',
                    tooltip: 'Share on Facebook',
                    iconImgUp: '/dist/common/assets/share/facebook.svg'
                },
                {
                    provider: 'twitter',
                    tooltip: 'Share on Twitter',
                    iconImgUp: '/dist/common/assets/share/twitter.svg'
                },
                {
                    provider: 'pinterest',
                    tooltip: 'Pin It!',
                    iconImgUp: '/dist/common/assets/share/pinterest.svg'
                },
                {
                    provider: 'print',
                    tooltip: 'Print',
                    iconImgUp: '/dist/common/assets/share/print.svg'
                }
            ],
            userAction: act,
            onLoad: function(event) {
                var container = document.querySelector('#' + event.containerID);
                var shareButtons = container.querySelectorAll('.gig-share-button');

                for (var x = 0; x < shareButtons.length; x++) {
                    shareButtons[x].setAttribute('tabindex', 0);
                    shareButtons[x].setAttribute('role', 'button');

                    shareButtons[x].addEventListener('keypress', function(keyEvent) {
                        if(keyEvent.charCode === 13) {
                            this.onclick();
                        }
                    });
                }
            }
        };

        this.$nextTick(() => {
            gigya.socialize.showShareBarUI(showShareBarUiParams);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-share-gigya.js